import * as THREE from "three";

const PrismGeometry = function (vertices, height) {
  var Shape = new THREE.Shape();

  (function f(ctx) {
    ctx.moveTo(vertices[0].x, vertices[0].y);
    for (var i = 1; i < vertices.length; i++) {
      ctx.lineTo(vertices[i].x, vertices[i].y);
    }
    ctx.lineTo(vertices[0].x, vertices[0].y);
  })(Shape);

  var settings: any = {};
  settings.amount = height;
  settings.bevelEnabled = false;
  THREE.ExtrudeGeometry.call(this, Shape, settings);
};

PrismGeometry.prototype = Object.create(THREE.ExtrudeGeometry.prototype);

const getArrowAxes = (last: boolean) => {
  var arrowScene = new THREE.Scene();
  var arrowPos = new THREE.Vector3(0, 0, 0);
  arrowScene.add(
    new THREE.ArrowHelper(
      new THREE.Vector3(1, 0, 0),
      arrowPos,
      10,
      14908283,
      1,
      1
    )
  );
  arrowScene.add(
    new THREE.ArrowHelper(
      new THREE.Vector3(0, 1, 0),
      arrowPos,
      10,
      6014811,
      1,
      1
    )
  );
  arrowScene.add(
    new THREE.ArrowHelper(
      new THREE.Vector3(0, 0, 1),
      arrowPos,
      10,
      7391718,
      1,
      1
    )
  );

  if (last) {
    // var grabberMaterial = new THREE.MeshBasicMaterial({ color: 0 });
    // const grabberPoints = [];
    // grabberPoints.push(new THREE.Vector3(0, 2.5, 0));
    // grabberPoints.push(new THREE.Vector3(0, -2.5, 0));
    // var grabberTubeGeometry = new THREE.TubeGeometry(
    //   new THREE.CatmullRomCurve3(grabberPoints),
    //   1,
    //   0.5
    // ); // Adjust radius for thickness
    // var grabberBase = new THREE.Mesh(grabberTubeGeometry, grabberMaterial);
    // arrowScene.add(grabberBase);
    // const geometry = new THREE.SphereGeometry(0.5, 32, 32);
    // const spherematerial = new THREE.MeshBasicMaterial({ color: 0 });
    // const sphere1 = new THREE.Mesh(geometry, spherematerial);
    // sphere1.position.set(0, 2.5, 0);
    // const sphere2 = new THREE.Mesh(geometry, spherematerial);
    // sphere2.position.set(0, -2.5, 0);
    // arrowScene.add(sphere1);
    // arrowScene.add(sphere2);
    // const geometry1 = new THREE.BoxGeometry(1, 0.5, 3);
    // const material = new THREE.MeshBasicMaterial({ color: 0 });
    // const cube1 = new THREE.Mesh(geometry1, material);
    // cube1.position.z = 1.5;
    // cube1.position.y = 2.5;
    // arrowScene.add(cube1);
    // const cube2 = new THREE.Mesh(geometry1, material);
    // cube2.position.z = 1.5;
    // cube2.position.y = -2.5;
    // arrowScene.add(cube2);
  }

  return arrowScene;
};

export { getArrowAxes };
